import React from "react";
import "../Technology/Technology.css";
import image1 from "../Assets/tech-2.png";
import image2 from "../Assets/tech-1.png";


function Technology() {
  return (
    <>
      <div className="technology">
      <div className="approved">
            <span >
              "State of the art WHO-GMP, ISO 9001:2008 and NPCB, PIC/S Malaysia
              approved manufacturing facility."
            </span>
            </div>
        <h1 >
          Technology at Medisol
        </h1>
        <div className="technology-container">
          <div className="technology-col-1">
            <p>
              We're in the <b>"competitive advantage"</b> business. Inhalation
              technology that helps put you in front, faster. Because it is
              target specific, inhalation drug delivery has fundamental
              advantages for therapy of diseases of the respiratory tract,
              including asthma and Chronic Obstructive Pulmonary Disease. Drugs
              administered by inhalation minimize systemic absorption and
              adverse effects compared with drugs that must travel through the
              gastrointestinal tract.<br/> <br/> This growing market continues to evolve as
              new developments expand this delivery route to larger molecules,
              such as proteins and peptides. Combined with its clear benefits,
              inhalation is poised to become the delivery route of choice for a
              wide variety of inhaled therapies, for both local and systemic
              drug delivery. MLPL Drug Delivery Systems is a leader in
              inhalation technology. More than just systems and components, MLPL
              delivers the expertise, efficiency and flexibility you need to
              gain a competitive advantage. We partner with you to resolve your
              formulation challenges, differentiate your pMDI products with
              optimized components, guide you through regulatory approval and
              meet worldwide production and supply needs.
            </p>
            <ul>
              <li>Ability to solve unique formulation challenges</li>
              <li>Unique components to protect and differentiate your pMDI product</li>
              <li>Unsurpassed support throughout the development process, including regulatory filings</li>
              <li>Flexible vertical integration in production and manufacturing saves time and money</li>
              <li>Worldwide production capabilities that meet rigorous global standards</li>
            </ul>
          </div>
          <div className="technology-col-2">
            <img src={image1} alt="" className="tech-image"/>
            <img src={image2} alt=""className="tech-image"/>
          </div>
        </div>
      </div>
    </>
  );
}
export default Technology;
